// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    [
      {
        "sub": "电工基础",
        "tec": "SYED M ALI孟垂懿",
        "week": "1-2,5-8,12周",
        "add": "319国教"
      },
      {
        "sub": "319国教",
        "tec": "SYED M ALI孟垂懿",
        "week": "13周",
        "add": "319国教"
      }
    ],
    [
      {
        "sub": "蒸汽产生概论",
        "tec": "佟连尧杨利",
        "week": "1-2,5-8,12周",
        "add": "113国教"
      },
      {
        "sub": "113国教",
        "tec": "佟连尧夏永军",
        "week": "13-18周",
        "add": "113国教"
      }
    ],
    [
      {
        "sub": "热工测量与仪表",
        "tec": "郭南",
        "week": "13周",
        "add": "319国教"
      },
      {
        "sub": "319国教",
        "tec": "郭南",
        "week": "14-18周",
        "add": "319国教"
      }
    ],
    {
      "sub": "蒸汽产生概论",
      "tec": "佟连尧杨利",
      "week": "13周",
      "add": "113国教"
    },
    0
  ],
  "2": [
    [
      {
        "sub": "综合英语3",
        "tec": "张琳",
        "week": "1-2,5-8,12-18周",
        "add": "动2"
      },
      {
        "sub": "103国教",
        "tec": "宋孚红",
        "week": "1-2,5-8,12-18周",
        "add": "动2"
      },
      {
        "sub": "104国教",
        "tec": "张楹",
        "week": "1-2,5-8,12-18周",
        "add": "动2"
      },
      {
        "sub": "106国教",
        "tec": "林铁",
        "week": "1-2,5-8,12-18周",
        "add": "动2"
      }
    ],
    {
      "sub": "原动机概论",
      "tec": "佟连尧夏永军",
      "week": "13-18周",
      "add": "113国教"
    },
    {
      "sub": "习近平新时代中国特色社会主义思想概论",
      "tec": "李进",
      "week": "1-2,5-8,13-14周",
      "add": "教学楼A座321电力"
    },
    [
      {
        "sub": "就业创业指导",
        "tec": "孔瀚",
        "week": "1-2,5-6,8周",
        "add": "教学楼C座113教务"
      },
      {
        "sub": "环保与水处理概论",
        "tec": "牛微董颖男",
        "week": "13-18周",
        "add": "教学楼C座302教务"
      }
    ],
    0
  ],
  "3": [
    [
      {
        "sub": "蒸汽产生概论",
        "tec": "佟连尧杨利",
        "week": "1-2,5-8,12周",
        "add": "319国教"
      },
      {
        "sub": "113国教",
        "tec": "佟连尧杨利",
        "week": "13周",
        "add": "319国教"
      },
      {
        "sub": "113国教",
        "tec": "郭南",
        "week": "14-18周",
        "add": "319国教"
      }
    ],
    [
      {
        "sub": "交际口语3",
        "tec": "外教9",
        "week": "1-2,5-8,12-18周",
        "add": "动1"
      },
      {
        "sub": "103国教",
        "tec": "外教8",
        "week": "1-2,5-8,12-18周",
        "add": "动1"
      },
      {
        "sub": "106国教",
        "tec": "外教7",
        "week": "1-2,5-8,12-18周",
        "add": "动1"
      },
      {
        "sub": "108国教",
        "tec": "外教6",
        "week": "1-2,5-8,12-18周",
        "add": "动1"
      }
    ],
    0,
    0,
    0
  ],
  "4": [
    [
      {
        "sub": "电工基础",
        "tec": "SYED M ALI孟垂懿",
        "week": "1-2,5-8,12周",
        "add": "502国教"
      },
      {
        "sub": "406国教",
        "tec": "郭南",
        "week": "13周",
        "add": "502国教"
      },
      {
        "sub": "502国教",
        "tec": "郭南",
        "week": "14-18周",
        "add": "502国教"
      }
    ],
    [
      {
        "sub": "综合英语3",
        "tec": "张楹",
        "week": "1-2,5-8,12-18周",
        "add": "动4"
      },
      {
        "sub": "106国教",
        "tec": "宋孚红",
        "week": "1-2,5-8,12-18周",
        "add": "动4"
      },
      {
        "sub": "104国教",
        "tec": "林铁",
        "week": "1-2,5-8,12-18周",
        "add": "动4"
      },
      {
        "sub": "108国教",
        "tec": "张琳",
        "week": "1-2,5-8,12-18周",
        "add": "动4"
      }
    ],
    [
      {
        "sub": "蒸汽产生概论",
        "tec": "佟连尧杨利",
        "week": "1-2,5-8,12周",
        "add": "113国教"
      },
      {
        "sub": "113国教",
        "tec": "佟连尧杨利",
        "week": "13周",
        "add": "113国教"
      }
    ],
    {
      "sub": "电工基础",
      "tec": "SYED M ALI孟垂懿",
      "week": "13周",
      "add": "319国教"
    },
    0
  ],
  "5": [
    {
      "sub": "习近平新时代中国特色社会主义思想概论",
      "tec": "李进",
      "week": "1-2,5-8,13-14周",
      "add": "教学楼A座425机械"
    },
    {
      "sub": "环保与水处理概论",
      "tec": "牛微董颖男",
      "week": "13-18周",
      "add": "教学楼C座302教务"
    },
    {
      "sub": "原动机概论",
      "tec": "佟连尧夏永军",
      "week": "13-18周",
      "add": "113国教"
    },
    {
      "sub": "热工测量与仪表",
      "tec": "郭南",
      "week": "13周",
      "add": "319国教"
    },
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
